(ns assemble.component.move-modal.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Dialog$default" :as Dialog]
            ["@mui/material/DialogActions$default" :as DialogActions]
            ["@mui/material/DialogContent$default" :as DialogContent]
            ["@mui/material/DialogTitle$default" :as DialogTitle]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-tree-view/SimpleTreeView" :refer [SimpleTreeView]]
            ["@mui/x-tree-view/TreeItem" :refer [TreeItem]]
            [assemble.component.file-tree.view :refer [collapse-icon expand-icon
                                                       folder-icon-wide]]
            [assemble.component.move-modal.db :as db]
            [clojure.set :as set]
            [clojure.string :as str]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui tree-item [{:keys [:asset-tree/name :asset-tree/id children disabled-folder-id current-item-id]}]
  ($ TreeItem
     {:itemId (str id)
      :label ($ Typography {:noWrap true} name)
      :slots #js {:endIcon folder-icon-wide}
      :sx #js {:color (if (or (= disabled-folder-id id) (= current-item-id id))
                        "grey.50"
                        "black")}}
     (when children
       (for [t children]
         ($ tree-item
            (merge t {:key (:asset-tree/id t)
                      :disabled-folder-id disabled-folder-id
                      :current-item-id current-item-id}))))))

(defui tree-from-root-node [{:keys [children disabled-folder-id current-item-id]}]
  (when children
    (for [t children]
      ($ tree-item
         (merge t {:key (:asset-tree/id t)
                   :disabled-folder-id disabled-folder-id
                   :current-item-id current-item-id})))))

(defui move-file-tree
  [{:keys [old-folder-id current-item-id]}]
  (let [tree (use-subscribe [::db/tree])
        current-node (use-subscribe [::db/selected-node])
        old-parent-nodes (use-subscribe [:assemble.page.assets.file-tree/parent-nodes])
        parents-expanded (vec (for [n old-parent-nodes]
                                (str (:asset-tree/id n))))
        expanded (use-subscribe [::db/expanded])]
    ($ SimpleTreeView
       {:expandedItems (to-array (or expanded parents-expanded))
        :selectedItems nil
        :slots #js {:expandIcon expand-icon
                    :collapseIcon collapse-icon}
        :onExpandedItemsChange (fn [^js e node-ids]
                                 (let [new-ids (set node-ids)
                                       closed-id (first (set/difference expanded new-ids))
                                       opened-id (first (set/difference new-ids expanded))]
                                   (when (or
                                          ;; If clicking directly on expand/collapse icon
                                          (.-expand (.-dataset (.-target e)))
                                          ;; Always open
                                          opened-id
                                          ;; Only close on item click, if the folder is already selected
                                          ;; so the first click only selects the item, second closes.
                                          (and closed-id (= closed-id (str current-node))))
                                     (rf/dispatch [::db/set-expanded (vec node-ids)]))))
        :onSelectedItemsChange (fn [_ node-id]
                                 (rf/dispatch [::db/select-node node-id]))
        :ref (fn [e] (when e (js/setTimeout #(.focus e) 100)))
        :sx #js {:minWidth "30rem"
                 :overflow "auto"

                 ;; Match Default MUI table row height
                 ".MuiTreeItem-content" #js {:height "52px"}
                 ".MuiTreeItem-content .MuiTreeItem-iconContainer" #js {:width "auto"}}}
       ($ tree-from-root-node
          {:children (get-in tree [:value :children])
           :disabled-folder-id old-folder-id
           :current-item-id current-item-id}))))

(defui location-path [{:keys [label parent-nodes]}]
  ($ Stack
     {:direction "row"
      :alignItems "center"
      :gap 1}
     ($ Typography
        {:variant "h5"}
        label ":")
     (when (seq parent-nodes)
       ($ Chip
          {:label (str/join " / " (map :asset-tree/name parent-nodes))
           :sx #js {:fontSize "h5.fontSize"}}))))

(defui move-modal [{:keys [on-submit-event type]}]
  (let [{:keys [modal-open item-id item-name old-folder-id children-ids move-folder?]} (use-subscribe [::db/props])
        new-folder-id (use-subscribe [::db/selected-node])
        ;; First item is root node, drop it.
        old-parent-nodes (rest (use-subscribe [:assemble.page.assets.file-tree/parent-nodes]))
        new-parent-nodes (rest (use-subscribe [::db/parent-nodes]))]
    ($ Dialog
       {:open (boolean modal-open)
        :onClose #(rf/dispatch [::db/close])
        :fullWidth true
        :maxWidth "lg"}
       ($ Stack
          {:component "form"
           :direction "column"
           :onSubmit (fn [e]
                       (.preventDefault e)
                       (rf/dispatch (into on-submit-event [item-id new-folder-id type])))}
          ($ DialogTitle
             {:variant "h2"
              :color "primary"}
             (str
              "Move "
              (cond
                move-folder? "folder "
                (= type :asset) "asset "
                (= type :template) "template ")
              "\"" item-name "\""))

          ($ DialogContent
             ($ Stack
                {:direction "row"
                 :gap 3
                 :sx #js {:mb "1rem"}}
                ($ location-path
                   {:label "Current location"
                    :parent-nodes old-parent-nodes})
                ($ location-path
                   {:label "New location"
                    :parent-nodes new-parent-nodes}))

             ($ Typography
                {:variant "h4"
                 :color "secondary"
                 :sx #js {:mt 3}}
                "Folders"))

          ;; file-tree has its own padding - placed outside of DialogContent
          ($ Box
             {:sx #js {:height "40rem"
                       :width "100%"
                       :overflow "scroll"}}
             ($ move-file-tree {:old-folder-id old-folder-id :current-item-id item-id}))

          ($ DialogActions
             ($ Button
                {:color "primary"
                 :onClick #(rf/dispatch [::db/close])}
                "Cancel")
             ($ Button
                {:variant "contained"
                 :color "primary"
                 :disabled (or (nil? new-folder-id)
                               (= new-folder-id old-folder-id)
                               (= new-folder-id item-id)
                               (some #(= new-folder-id %) children-ids))
                 :type "submit"}
                "Move"))))))
